export default "__VITE_ASSET__CJezo5XY__"